import {GetCurrentLoginInformationsOutput,
    AccountServiceProxy,
    SessionServiceProxy, IsTenantAvailableInput, AuthenticateResultModel, TokenAuthServiceProxy, RefreshTokenResult
} from "../services/shared/service-proxies/service-proxies";
import {AppConsts} from "../core/AppConsts";
import {AxiosConfigure} from "../core/AxiosConfigure";
import {StoreService} from "../services/store-service";

export class AuthService {
    _sessionServiceProxy: SessionServiceProxy;
    _accountServiceProxy: AccountServiceProxy;
    _tokenAuthServiceProxy: TokenAuthServiceProxy;

    constructor(token: string | "") {
        if (token) {
            this._sessionServiceProxy = new SessionServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());
            this._accountServiceProxy = new AccountServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());
            this._tokenAuthServiceProxy = new TokenAuthServiceProxy(AppConsts.appBaseUrl, AxiosConfigure.getInstance());
        } else {
            this._sessionServiceProxy = new SessionServiceProxy(AppConsts.appBaseUrl);
            this._accountServiceProxy = new AccountServiceProxy(AppConsts.appBaseUrl);
            this._tokenAuthServiceProxy = new TokenAuthServiceProxy(AppConsts.appBaseUrl);
        }
    }

    getCurrrentSession(): Promise<GetCurrentLoginInformationsOutput> {
        return this._sessionServiceProxy.getCurrentLoginInformations();
    }


    isTenantAvalabel(tenantName: string) {
        var data = new IsTenantAvailableInput();
        data.tenancyName = tenantName;
        return this._accountServiceProxy.isTenantAvailable(data);
    }

    getRefreshToken(): Promise<RefreshTokenResult> {
        const user = StoreService.GetData("user");
        return this._tokenAuthServiceProxy.refreshToken(user.refreshToken);
    }
}
